// extracted by mini-css-extract-plugin
export var cardHeader = "_tg-0";
export var reorderHandle = "_tg-3";
export var titleArea = "_tg-1";
export var titleAreaWithHandle = "_tg-2";